import { useCallback } from 'react';
import { useQuery, gql } from 'urql';
import { TicketDeliveryMethod } from '../modal-invitation/api/updateSetting';

const GET_SETTINGS_BY_EVENT_ID = gql`
  query GetSettingsByEventId($eventId: Int!) {
    getSettingsByEventId(eventId: $eventId) {
      id
      eventId
      showFioInApp
      skipTicketsOnAccept
      invitationExpiresAt
      sendTicketAfterAcceptAt
      ticketDeliveryMessage
      ticketDeliveryMethod
      emailTicketDeliveryMessage
      inviteSentAt
      inviteAcceptionInfo
      invitationEmailSubject
      ticketEmailSubject
      calendarMeetingDescription
      calendarMeetingDateStart
      calendarMeetingDateEnd
      calendarMeetingPoint
      calendarMeetingId
      sendTicketsOnEventDayAt
    }
  }
`;

const useGetSettingsByEventId = (eventId: number) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_SETTINGS_BY_EVENT_ID,
    variables: { eventId },
    pause: !eventId,
  });

  const { data, fetching, error } = result;
  const refetch = useCallback(
    () =>
      reexecuteQuery({
        requestPolicy: 'network-only',
      }),
    [reexecuteQuery]
  );

  return {
    data: data?.getSettingsByEventId,
    isLoading: fetching,
    error,
    refetch,
  };
};

export interface EventSettings {
  id: number;
  eventId: number;
  showFioInApp: boolean | null;
  skipTicketsOnAccept: boolean | null;
  invitationExpiresAt: string | null;
  sendTicketAfterAcceptAt: string | null;
  ticketDeliveryMessage: string | null;
  emailTicketDeliveryMessage: string | null;
  inviteSentAt: string | null;
  ticketDeliveryMethod: TicketDeliveryMethod[] | null;
  inviteAcceptionInfo: string | null;
  invitationEmailSubject: string | null;
  ticketEmailSubject: string | null;
  calendarMeetingDescription: string | null;
  calendarMeetingDateStart: string | null;
  calendarMeetingDateEnd: string | null;
  calendarMeetingPoint: string | null;
  calendarMeetingId: string | null;
  sendTicketsOnEventDayAt: string | null;
}

export default useGetSettingsByEventId;
